module.exports = __webpack_public_path__ + "media/images/Ellipse-active-eabcb4ddf5b1e3e6d14152866d0519bd.svg";